import { Tag, Tooltip } from 'antd'
import { LibraTicket } from 'features/libra/ticket/libraTicketsApi'
import { LIBRA_WORKFLOW_ENTRY_TYPE } from 'features/libra/workflow/workflowStepsApi'
import { useGeckoNotifications } from 'features/notifications'
import { ExternalLink } from 'lucide-react'
import { FC, memo, useCallback } from 'react'
import styled from 'styled-components'

const StyledNavigationTag = styled(Tag)`
  cursor: pointer;
  color: ${({ theme }) => theme.forecast.activeText};
  background-color: ${({ theme }) => theme.forecast.background3};
  border-color: ${({ theme }) => theme.forecast.background3};

  &:hover {
    background-color: ${({ theme }) => theme.forecast.background2};
  }
`

function createUrl(
  orgId: string,
  workflowId: string,
  ticketId: string
): string {
  return `/libra/${orgId}/${workflowId}?ticket=${ticketId}`
}

const RawOpenTicketButton: FC<{
  ticket: LibraTicket
}> = ({ ticket }) => {
  const { errorNotification } = useGeckoNotifications()
  const handleClick = useCallback(() => {
    const orgId = ticket.tags['organization'] as string | undefined
    const workflowId = ticket.tags[LIBRA_WORKFLOW_ENTRY_TYPE] as
      | string
      | undefined
    const ticketId = ticket.id
    if (!orgId || !workflowId || !ticketId) {
      errorNotification(
        'Unable to open ticket - missing orgId, workflowId, or ticketId'
      )
      return
    }
    const url = createUrl(orgId, workflowId, ticketId)
    window.open(url, '_blank')
  }, [errorNotification, ticket.id, ticket.tags])

  return (
    <Tooltip title='Open Ticket' placement='topLeft'>
      <StyledNavigationTag onClick={handleClick}>
        <ExternalLink />
      </StyledNavigationTag>
    </Tooltip>
  )
}

export const OpenTicketButton = memo(RawOpenTicketButton)
